import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MovieService,Movies } from 'src/app/Core/services/movie.service';
import { UtilService } from 'src/app/Core/services/util.service';

declare var $: any;
interface Category {
  category_id: string;
  category_name: string;
}

interface Movie {
  name: string;
  stream_id: number;
  category_id: string;
  stream_icon:string;
  container_extension:string;
  tmdb_id:number;
  rating:string;
  stream_type:string;
}
@Component({
  selector: 'app-movies',
  templateUrl: './movies.component.html',
  styleUrls: ['./movies.component.css']
})

export class MoviesComponent implements OnInit {
  isLoading: any;
  isCategory = true;
  filterTerm: string;
  // categories: any;
  defaultCategoryList: any;
  categoryId: any;
  allMovieCat:any
  id:boolean =false
  selectedcategory: any;
  isDesc: boolean = false;
  laodCategories:boolean =false;
  stopPromise :boolean =  false;

  batch:any=[]
  column: string = 'CategoryName';
  sortButton: any = [{ label: 'Default', val: 'default', selected: true },
  { label: 'A - Z', val: 'atoz', selected: false },
  { label: 'Z - A', val: 'ztoa', selected: false },
  ];
  translate=['COMMON.DEFAULT','COMMON.A-Z','COMMON.Z-A'];

  categories: Category[] = [];
  movies: Movie[] = [];
  selectedCategoryId = '';
  page = 1;
  limit = 50;
  movie:any
  
  constructor(private movieservice: MovieService, private utilService: UtilService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe((param: any) => {
      
      console.log(param);
      this.categoryId = param.category;
      if (this.categoryId)
        this.updateCategory(param.category)
        // this.updateCategory(null)
    })
  }

 async ngOnInit() {
   const state = history.state;
    this.categoryId = state.id;
    // this.getMovieCategory();
    this.categories = await this.movieservice.loadCategories();
    this.defaultCategoryList = this.categories;
    console.log('Categories:', this.categories);
    // this.selectedcategory = await this.categories;
    const total = await this.movieservice.loadMovies();
    if(total){
     this.id = true;
     this.updateSelectedId('all')
    }
    console.log(this.movie);
    
    // if (!this.categoryId) {
    //   this.updateCategory(79);
    // }
  }

  updateSelectedId(categoryId:string){
    console.log(categoryId);
    if(categoryId === 'all'){
      this.selectedcategory = categoryId;
      this.id = true;
      this.categories?.map((ele: any, index) => {
        (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
      });
    }else{
      this.id = false;
      this.selectedcategory = categoryId;
      this.categories?.map((ele: any, index) => {
        (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
      });
    }
    // this.page = 1;
    // if(categoryId === 'all')
    //   {
    //     this.movie = this.movieservice.loadMovies();

    //   }
  }

  getMovieCategory() {
    this.utilService.showSpinner()
    this.isLoading = true;
    this.movieservice.getVodCategories().subscribe((res: any) => {
     if(res.content)
     {
      this.categories = res.content;
       this.defaultCategoryList = res.content;
       this.categories.map((ele: any, index) => {
        if (this.categoryId) {
          if (ele.category_id == this.categoryId) {
            //  this.categoryIdPass=ele.category_id;
            ele.select = true;
          }
        } else {
          if (index == 0) {
            // this.categoryIdPass=ele.category_id;
            ele.select = true;
            this.updateCategory(ele.category_id);
            // this.updateCategory(null);
            // this.id =true
          }
          else { ele.select = false; }
        }
      });
     }
      else{
       this.utilService.hideSpinner()
       this.isLoading = false;
       this.categories = res;
       this.defaultCategoryList = res;
       this.categories.map((ele: any, index) => {
        if (this.categoryId) {
          if (ele.category_id == this.categoryId) {
            //  this.categoryIdPass=ele.category_id;
            ele.select = true;
          }
        } else {
          if (index == 0) {
            // this.categoryIdPass=ele.category_id;
            ele.select = true;
            this.updateCategory(ele.category_id);
            // this.updateCategory(null);
            // this.id =true
          }
          else { ele.select = false; }
        }
      });
    } 
    }, err => {
    this.utilService.hideSpinner()
    this.isLoading = false;
    this.laodCategories = true;
    this.utilService.showErrorCall(err);
    });
  }

  loadMoviesCategories(){
    this.isLoading = true;
    this.movieservice.getVodCategories().subscribe((res: any) => {
     if(res){
       this.laodCategories = false;
       this.isLoading = false;
       this.categories = res;
       this.defaultCategoryList = res;
       this.categories.map((ele: any, index) => {
        if (this.categoryId) {
          if (ele.category_id == this.categoryId) {
            //  this.categoryIdPass=ele.category_id;
            ele.select = true;
          }
        } else {
          if (index == 0) {
            // this.categoryIdPass=ele.category_id;
            ele.select = true;
            this.updateCategory(ele.category_id);
            // this.updateCategory(null);
            // this.id =true
          }
          else { ele.select = false; }
        }
      });
    } 
    }, err => {
    this.utilService.hideSpinner()
    this.isLoading = false;
    this.laodCategories = true;
    this.utilService.showErrorCall(err);
    });
  }
  // async loadData() {
  //   try {
  //     // this.utilService.showSpinner();
  //     // this.isLoading = true;
  //     const res: any= await this.movieservice.selectedCategoryWiseStreamDatas().toPromise();
  //     console.log(res,'response');
      
  //     if (!res || !Array.isArray(res)) {
  //       throw new Error("Invalid response data.");
  //     }
  
  //     if (res.length === 0) {
  //       this.id = false;
  //       this.utilService.showErrorCall("No data found.");
  //       return;
  //     }
  
  //     const batchSize = 100;
  //     let startIndex = 0;
  //     let allData: any[] = [];
  //     while (startIndex < res.length && !this.stopPromise) {
  //       const endIndex = Math.min(startIndex + batchSize, res.length);
  //       this.batch = res.slice(startIndex, endIndex);
  //       allData = allData.concat(this.batch); // Concatenate the batch data with the accumulated data
  //       this.selectedcategory = allData;
  //       console.log(this.batch, 'Batch of movies',endIndex);
  //       startIndex += batchSize;
  
  //       await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 2 seconds before loading the next batch
  //     }
  
  //     console.log("All data loaded.");
  //     this.id = true;
  //     $(window).scrollTop(0);
  //   } catch (err) {
  //     this.id = false;
  //     this.utilService.hideSpinner();
  //     this.isLoading = false;
  //     this.utilService.showErrorCall(err.message || err);
  //   }
  // }
  async loadData() {
    try {
      // this.utilService.showSpinner();
      // this.isLoading = true;
      
      const res: any = await this.movieservice.selectedCategoryWiseStreamDatas().toPromise();
      console.log(res, 'response');

      // Check if `res.content` exists and is an array, otherwise use `res`
      const data = res && Array.isArray(res.content) ? res.content : res;

      if (!data || !Array.isArray(data)) {
        throw new Error("Invalid response data.");
      }

      if (data.length === 0) {
        this.id = false;
        this.utilService.showErrorCall("No data found.");
        return;
      }

      const batchSize = 100;
      let startIndex = 0;
      let allData: any[] = [];
      
      while (startIndex < data.length && !this.stopPromise) {
        const endIndex = Math.min(startIndex + batchSize, data.length);
        this.batch = data.slice(startIndex, endIndex);
        allData = allData.concat(this.batch); // Concatenate the batch data with the accumulated data
        this.selectedcategory = allData;
        console.log(this.batch, 'Batch of movies', endIndex);
        startIndex += batchSize;

        await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 1 second before loading the next batch
      }

      console.log("All data loaded.");
      this.id = true;
      $(window).scrollTop(0);
    } catch (err) {
      this.id = false;
      this.utilService.hideSpinner();
      this.isLoading = false;
      this.utilService.showErrorCall(err.message || err);
    }
}


  
  

  updateCategory(id) {
    this.utilService.showSpinner()
    this.isLoading = true;
    //  this.categoryIdPass=id;
    //  console.log(this.categoryIdPass,id);
    this.utilService.filterResetObservable.next(true);
    console.log(id,'id ');
    
    if(id === null){
      this.stopPromise = false;
      this.utilService.hideSpinner()
      this.isLoading =false
      this.loadData()
      // this.utilService.showSpinner()
      // this.isLoading = true;
      // this.movieservice.selectedCategoryWiseStreamData(id).subscribe((res: any) => {
       
      //   this.utilService.hideSpinner()
      //   this.isLoading = false;
      //   console.log(res.length,'res');
        
      //   this.id=true
      //   setTimeout(() => {
      //       this.allMovieCat = res.slice(0, 50);
      //       console.log(this.allMovieCat,'all movies');
            
      //         this.selectedcategory = this.allMovieCat;
      //       $(window).scrollTop(0);
      //     }, 1000);
      //   }, err => {
      //   this.id =false
      //   this.utilService.hideSpinner()
      //   this.isLoading = false;
      //     this.utilService.showErrorCall(err);
      //   });
    }else{
    this.stopPromise = true;
    this.utilService.showSpinner()
    this.movieservice.selectedCategoryWiseStreamData(id).subscribe((res: any) => {
    this.utilService.hideSpinner()
    this.isLoading = false;
    this.id=false
    if(res.content){
      this.selectedcategory = res.content;

    }else{
      
      this.selectedcategory = res;
    }
   
      setTimeout(() => {
        $(window).scrollTop(0);
      }, 1000);
    }, err => {
    this.utilService.hideSpinner()
    this.isLoading = false;
      this.utilService.showErrorCall(err);
    });
    }

    this.categories?.map((ele: any, index) => {
      (ele.category_id == id) ? ele.select = true : ele.select = false;
    });


  }

  // sort(property) {
  //   this.isDesc = !this.isDesc;//change the direction   
  //   this.utilService.commonSort(this.isDesc, property, this.categories);
  // };
  sort(property, subtype: any) {
    let ascDesc;
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });

    if (subtype == 'default') {
      this.categories = this.defaultCategoryList;
    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    if (ascDesc) {
      this.utilService.sortCommonCategorywise(property, ascDesc, this.categories, (callback) => {
        this.categories = callback;
      });
    }
  }

  translateFilter(index:any):string{
    return this.translate[index]
  }
}
